import React, { useState, useEffect } from 'react'

import { DotsCircleLoader } from '@reactiveonline/frontend_shared_components'
import ServiceItem from '../../services/ServiceItem'
import listStyles from '../../services/listStyles'

export default function Service({ item, deviceType, extraData }) {
  const { settings } = item
  const { id, classes, viewType } = settings
  const appProps = extraData
  const itemViewType = viewType || 'overlay'

  const [entities, setEntities] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect( () => {
    fetchEntity()
  }, [])

  async function fetchEntity() {
    const entity = settings.item

    if (entity) {
      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: `${ appProps.selectedServicesPath }?items=${ JSON.stringify([entity]) }`,
        dataType: 'json',
        success: result => {
          if (result.items) {
            setEntities(result.items)
          }
        },
        complete: result => {
          setLoading(false)
        }
      })
    }
  }

  return (
    <div
      id={ id || item.id }
      className={ `rb-service ${ classes || '' } flex-box flex-wrap` }
    >
      { entities.map( (entity, index) =>
        <ServiceItem
          key={ index }
          appProps={ appProps }
          service={ entity }
          servicesPerRowClass='one_item'
          serviceListStyle={ `${ itemViewType }-style` }
        />
      )}

      <style dangerouslySetInnerHTML={{ __html: `
        #${ id || item.id } { ${ listStyles(1, appProps.currentDevice) }}
      `}}/>

      { loading &&
        <div className='flex-box items-center content-center flex-1'>
          <DotsCircleLoader/>
        </div>
      }
    </div>
  )
}
